"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _baseService = _interopRequireDefault(require("@/config/base-service"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var DashboardService = /*#__PURE__*/function (_BaseService) {
  function DashboardService() {
    _classCallCheck(this, DashboardService);
    return _callSuper(this, DashboardService, ["dashboard"]);
  }
  _inherits(DashboardService, _BaseService);
  return _createClass(DashboardService, [{
    key: "fetchDataConsolidatedCreatedHive",
    value: function fetchDataConsolidatedCreatedHive(params) {
      return this.get("get-consolidated-created-hive", {
        params: params
      });
    }
  }, {
    key: "fetchDataConsolidatedCreatedProvider",
    value: function fetchDataConsolidatedCreatedProvider(params) {
      return this.get("get-consolidated-created-provider", {
        params: params
      });
    }
  }, {
    key: "fetchDataConsolidatedReceivedHive",
    value: function fetchDataConsolidatedReceivedHive(params) {
      return this.get("get-consolidated-received-hive", {
        params: params
      });
    }
  }, {
    key: "fetchDataConsolidatedSendClient",
    value: function fetchDataConsolidatedSendClient(params) {
      return this.get("get-consolidated-send-client", {
        params: params
      });
    }
  }, {
    key: "fetchLastResults",
    value: function fetchLastResults() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
      var params = {
        params: {
          page: page,
          limit: perPage
        }
      };
      return this.get("transactions/lastresults/".concat(time), params);
    }
  }, {
    key: "fetchConsumptionDetail",
    value: function fetchConsumptionDetail(operationid) {
      return this.get("lastresults/detail/".concat(operationid));
    }
  }, {
    key: "fetchConsumption",
    value: function fetchConsumption() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
      var params = arguments.length > 1 ? arguments[1] : undefined;
      return this.get("transactions/consumption/".concat(time), {
        params: params
      });
    }
  }, {
    key: "fetchDetailServiceDashboard",
    value: function fetchDetailServiceDashboard(period) {
      var params = _objectSpread({}, period);
      return this.get("services-actives", {
        params: params
      });
    }
  }, {
    key: "fetchLatestServiceCallDashboard",
    value: function fetchLatestServiceCallDashboard(period) {
      var params = _objectSpread({}, period);
      return this.get("services-actives/list", {
        params: params
      });
    }
  }, {
    key: "fetchLatestServiceCallChartDashboard",
    value: function fetchLatestServiceCallChartDashboard(period) {
      var params = _objectSpread({}, period);
      return this.get("services-actives/chart", {
        params: params
      });
    }
  }, {
    key: "fetchLatestServiceCallTotalDashboard",
    value: function fetchLatestServiceCallTotalDashboard(period) {
      var params = _objectSpread({}, period);
      return this.get("services-actives/total", {
        params: params
      });
    }
  }, {
    key: "fetchLatestServiceCallTotalMonetizablesDashboard",
    value: function fetchLatestServiceCallTotalMonetizablesDashboard(period) {
      var params = _objectSpread({}, period);
      return this.get("services-actives/totalmonetizables", {
        params: params
      });
    }
  }, {
    key: "fetchLatestServiceCallTotalErrorsDashboard",
    value: function fetchLatestServiceCallTotalErrorsDashboard(period) {
      var params = _objectSpread({}, period);
      return this.get("services-actives/totalerrors", {
        params: params
      });
    }
  }, {
    key: "fetchTimesDocumentoscopia",
    value: function fetchTimesDocumentoscopia(period) {
      var params = _objectSpread({}, period);
      return this.get("validacao-1xn/poc", {
        params: params
      });
    }
  }, {
    key: "fetchListErrorsDashboard",
    value: function fetchListErrorsDashboard(params) {
      return this.get("error-list", {
        params: params
      });
    }
  }, {
    key: "fetchDetailServiceActiveDashboard",
    value: function fetchDetailServiceActiveDashboard(payload) {
      var params = _objectSpread({}, payload);
      return this.get("services-actives/service/".concat(payload.Asset), {
        params: params
      });
    }
  }, {
    key: "featchLastServiceActiveCallsTotal",
    value: function featchLastServiceActiveCallsTotal(payload) {
      var params = _objectSpread({}, payload);
      return this.get("services-actives/service/".concat(payload.Asset, "/total"), {
        params: params
      });
    }
  }, {
    key: "featchLastServiceActiveCallsTotalMonetizables",
    value: function featchLastServiceActiveCallsTotalMonetizables(payload) {
      var params = _objectSpread({}, payload);
      return this.get("services-actives/service/".concat(payload.Asset, "/totalmonetizables"), {
        params: params
      });
    }
  }, {
    key: "featchLastServiceActiveCallsTotalErros",
    value: function featchLastServiceActiveCallsTotalErros(id, params) {
      return this.get("services-actives/service/".concat(id, "/erros"), {
        params: params
      });
    }
  }, {
    key: "fetchListErrorsTransactions",
    value: function fetchListErrorsTransactions() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
      var params = arguments.length > 1 ? arguments[1] : undefined;
      return this.get("transactions/erros/list", {
        params: _objectSpread(_objectSpread({}, params), {}, {
          days: time
        })
      });
    }
  }, {
    key: "fetchListErrorsReceptionist",
    value: function fetchListErrorsReceptionist() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
      var params = arguments.length > 1 ? arguments[1] : undefined;
      return this.get("erros/total/transactions", {
        params: _objectSpread(_objectSpread({}, params), {}, {
          days: time
        })
      });
    }
  }, {
    key: "fetchLastTransactionsReceptionist",
    value: function fetchLastTransactionsReceptionist() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
      var params = {
        params: {
          page: page,
          limit: perPage
        }
      };
      return this.get("receptionist/lastresults/".concat(time), params);
    }
  }, {
    key: "fetchNumberOfItensInLastDays",
    value: function fetchNumberOfItensInLastDays(type) {
      var days = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.get("protocols/get-number-of-itens-in-last-days/".concat(type, "/").concat(days));
    }
  }, {
    key: "fetchConsolidatedQuantitiesOfProtocolsInLastDaysByType",
    value: function fetchConsolidatedQuantitiesOfProtocolsInLastDaysByType(type) {
      var days = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.get("get-consolidated-quantities-of-protocols-in-last-days-by-type?type=".concat(type, "&days=").concat(days));
    }
  }, {
    key: "fetchConsolidatedGetsInLastDays",
    value: function fetchConsolidatedGetsInLastDays() {
      var days = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return this.get("get-consolidated-gets-in-last-days?days=".concat(days));
    }
  }, {
    key: "fetchProtocolsDetailsByPhaseGroupByTypeInLastDays",
    value: function fetchProtocolsDetailsByPhaseGroupByTypeInLastDays(phase, group) {
      var days = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      return this.get("".concat(phase, "/detail?days=").concat(days, "&group=").concat(group));
    }
  }, {
    key: "consultProtocolComplete",
    value: function consultProtocolComplete(payload) {
      return this.post(payload, "consult/protocols");
    }
  }, {
    key: "fetchChartIPs",
    value: function fetchChartIPs(params) {
      return this.get("consult/transactions-ips", {
        params: _objectSpread({}, params)
      });
    }
  }, {
    key: "fetchChartPaths",
    value: function fetchChartPaths(params) {
      return this.get("consult/transactions-paths", {
        params: _objectSpread({}, params)
      });
    }
  }, {
    key: "fetchChartErrors",
    value: function fetchChartErrors(params) {
      return this.get("consult/transactions-status-code", {
        params: _objectSpread({}, params)
      });
    }
  }, {
    key: "fetchErrors",
    value: function fetchErrors(params) {
      return this.get("consult/transactions-errors", {
        params: _objectSpread({}, params)
      });
    }
  }, {
    key: "fetchtListAllBUUsernames",
    value: function fetchtListAllBUUsernames() {
      return this.get("services-actives/alias-bu");
    }
  }]);
}(_baseService.default);
var _default = exports.default = new DashboardService();